import * as Yup from "yup";

// Blank = no target
const optionalPct = Yup.number()
    .transform((value, original) => (original === '' || original === null ? undefined : value))
    .typeError("Must be a number")
    .min(0, "Must be 0 or more")
    .max(100, "Must be 100 or less")
    .notRequired();

export const BillabilityUtilizationTargetFormValidation = Yup.object({
    fiscalYear: Yup.number()
        .required("Fiscal year is required")
        .integer("Fiscal year must be a whole number")
        .min(2000, "Fiscal year looks too early")
        .max(2100, "Fiscal year looks too late"),
    utilizationTarget: Yup.number()
        .required("Utilization target is required")
        .min(0, "Must be 0 or more")
        .max(100, "Must be 100 or less"),
    actualBillableTarget: Yup.number()
        .required("Actual billable target is required")
        .min(0, "Must be 0 or more")
        .max(100, "Must be 100 or less"),
    leadsTarget: optionalPct,
    principalsTarget: optionalPct,
});
